import { Component, inject, Signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { MatterFileType } from '@models/matter';
import { Note } from '@models/matter-notes';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterNotesState } from '@state/matter/notes';
import {
	CreateNoteComponent,
	CreateNoteData,
} from '../../create-note/create-note.component';
import { TestHooks } from './notes.hooks';
import { ModalService } from '@ui/modal/modal.service';

@Component({
	selector: 'app-sale-to-nav-notes',
	templateUrl: './notes.component.html',
	standalone: false,
})
export class NotesComponent {
	public testHooks = TestHooks;
	public ICON = ICON;
	public showNotesDropdown = false;

	public modalService = inject(ModalService);
	notes: Signal<Note[]> = select(MatterNotesState.getAll);

	@ViewSelectSnapshot(SelectedMatter.matterFileType)
	matterFileType: MatterFileType;

	constructor(private dialog: MatDialog) {}

	trackByNote(index: number, item: Note) {
		return item.id;
	}

	selectNote(noteId: string) {
		const data: CreateNoteData = {
			id: noteId,
		};
		this.modalService.openModal(CreateNoteComponent, {
			title: 'Edit note',
			data,
		});
	}

	addNote() {
		this.modalService.openModal(CreateNoteComponent, {
			title: 'Create note',
		});
	}
}
